export const isEmptyObject = (value) => value
  && Object.keys(value).length === 0
  && Object.getPrototypeOf(value) === Object.prototype;
